import React from 'react';

import PageTemplate from '../../../components/template/PageTemplate';
import { ACCOUNT_USER_PAGE_NAME } from '../../../constants/service/app/accountUserConstants';
import AccountUserList, { useAccountUserListViewModel } from '../../../views/account/user/list/AccountUserList';

const AccountUserListPage = (): JSX.Element => {
  const accountUserListViewModel = useAccountUserListViewModel();
  return (
    <PageTemplate pageName={ACCOUNT_USER_PAGE_NAME.USER_LIST}>
      <AccountUserList {...accountUserListViewModel} />
    </PageTemplate>
  );
};

export default AccountUserListPage;
